import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=5d241c3f&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports